
export default function FeatMapTrgBlock(props: any) {

    const {trgCatFeatObj} = props    // trgCatFeatObj == {'catUID': 'ffe2c190f1eb7454', 'catID': '30000720', 'catName': 'Blush', 'featUID': '3ad0a9d0646f4a52', 'featID': 'EAN', 'featName': 'EAN', 'featType': 'multiselect', 'featStatus': 0, 'featUnit': None}

    // let featsObj = trgCatFeatObj.features
    // let subObj = JSON.parse(JSON.stringify(trgCatFeatObj))
    // subObj = {...subObj, ...featsObj}
    // delete subObj.features

    const nameReducer = (f_str: any, max_len: number) => {
        if (f_str && f_str.length > max_len) {
            f_str = f_str.slice(0, max_len) + '...'
        }
        return f_str
    }

    // todo: reduce names for all attrs ...
    trgCatFeatObj['catName'] = nameReducer(trgCatFeatObj['catName'], 22)

    const keysToLabels = {
        catID: 'Category ID',
        catName: 'Category Name',
        featID: 'Feature ID',
        featName: 'Feature Name',
        featType: 'Feature Type',
        featStatus: 'Class',
        featUnit: 'Unit(s)',
        trgValName: 'Target Value',
    }

    const trgFields: any = [];

    for (const [key, val] of Object.entries(keysToLabels)) {
    // for (let key in keysToLabels) {  => &&  {keysToLabels[key as keyof typeof keysToLabels]}
        trgFields.push(
                <div key={key} className="featmap-trg-subcont">

                    <div className="field-label">{val}</div>
                    <input
                        id={key}
                        name={key}
                        type="text"
                        className={(key === 'featName' || key === 'trgValName') ? 'readonly-input bold' : 'readonly-input'}
                        value={trgCatFeatObj[key] ? trgCatFeatObj[key] : ''}
                        readOnly
                    />
                </div>
            )
        }

    return (
        <div className="featmap-trg-container" style={{position: 'relative'}}> {trgFields} </div>
    )
}